const HeartIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.4185 13.9393C8.189 14.0202 7.811 14.0202 7.5815 13.9393C5.624 13.2719 1.25 10.4876 1.25 5.76854C1.25 3.68539 2.93075 2 5.003 2C6.2315 2 7.31825 2.59326 8 3.51011C8.68175 2.59326 9.77525 2 10.997 2C13.0693 2 14.75 3.68539 14.75 5.76854C14.75 10.4876 10.376 13.2719 8.4185 13.9393Z" stroke="#062319" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default HeartIcon;